import axios from 'axios';

const client = axios.create({ withCredentials: true, timeout: 30000 });
client.interceptors.response.use(response => response, error => {
    if (error.response && error.response.status === 401) {
        window.dispatchEvent(new Event('authentication-expired'));
    }
    return Promise.reject(error);
});

// Fetch-based recording calls keep the same response contract as before.
export async function apiFetch(url, options = {}) {
    const response = await fetch(url, { credentials: 'include', ...options });
    if (!response.ok) {
        if (response.status === 401) window.dispatchEvent(new Event('authentication-expired'));
        throw new Error(`Запрос не выполнен (${response.status})`);
    }
    return response;
}

export default client;
